<template>
    <div>
        <v-form v-model="formValidity" ref="form">
            <v-layout row wrap>
                <v-flex xs12 mx-3>
                    <h5>Excess Order Acknowledgment:</h5>
                </v-flex>
                <v-flex xs12 mx-3>
                    <span>
                        Normally, no more than a total of five certified copies of a birth certificate are requested in a person’s lifetime.  Therefore, any time four or more certified copies are requested we must have an acknowledgment statement with your order.
                    </span>
                </v-flex>
                <v-flex xs12 md9 mx-3 my-3 align-self-center v-if="!isVssRequest">
                    <span>
                        I acknowledge I am requesting multiple certified copies of a birth certificate. I understand my acknowledgement statement will be filed with the birth certificate listed above and that this establishes I accept responsibility for safe-guarding the certified copies I am requesting
                    </span>
                </v-flex>
                <v-flex xs12 md9 mx-3 my-3 align-self-center v-if="isVssRequest">
                    <span>
                        I acknowledge that multiple copies of the birth certificate I am requesting have been requested in the past. I understand my acknowledgement statement will be filed with the birth certificate listed above and that this establishes I accept responsibility for safe-guarding the certified copies I am requesting.
                    </span>
                </v-flex>
                <v-flex xs12 md2 mx-3 align-self-center>
                    <v-checkbox v-model="excessAckData.excessOrderAck" required :rules="requiredRule"></v-checkbox>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
export default {
    name: 'certificate-excess-order-form',
    props: {
        canEdit: Boolean,
        excessAckProp: {},
        isVssRequest: Boolean
    },
    data: () => {
        return {
            formValidity: false,
            requiredRule: [v => !!v || 'Required'],
            excessAckData: {
                excessOrderAck: false
            }
        }
    },
    methods: {
        validate () {
            var valid = this.$refs.form.validate()
            return valid
        },
        getData () {
            this.$emit('data', this.excessAckData)
        }
    },
    watch: {
        excessAckProp: {
            handler (newVal, oldVal) {
                if (oldVal == null) return
                this.excessAckData = newVal
            },
            deep: true
        }
    }
}
</script>

<style>

</style>
